import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchComgate_municipalityId_idCancel = z.any()
export type TagsPatchComgate_municipalityId_idCancel = z.infer<typeof tagsPatchComgate_municipalityId_idCancel>

export const paramsPatchComgate_municipalityId_idCancel = z.object({ "id": z.string().uuid(), "municipalityId": z.string().uuid() })
export type ParamsPatchComgate_municipalityId_idCancel = z.infer<typeof paramsPatchComgate_municipalityId_idCancel>

export const responsePatchComgate_municipalityId_idCancel = z.object({ "payload": z.object({ "id": z.string().max(191), "package": z.union([z.literal("TRIAL"), z.literal("STANDARD"), z.literal("VIP")]), "price": z.number().int().gte(-2147483648).lte(2147483647), "vat": z.string(), "createdAt": z.string(), "updatedAt": z.string(), "validFrom": z.string(), "validUntil": z.string(), "paidAt": z.union([z.string(), z.null()]), "cancelledAt": z.union([z.string(), z.null()]), "userId": z.string().max(255), "municipalityId": z.string().max(255) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchComgate_municipalityId_idCancel = z.infer<typeof responsePatchComgate_municipalityId_idCancel>

interface IPatchComgate_municipalityId_idCancel extends BaseMethodType {
  tags: TagsPatchComgate_municipalityId_idCancel,
  params: ParamsPatchComgate_municipalityId_idCancel,
  response: ResponsePatchComgate_municipalityId_idCancel
}
export const URL = '/comgate/:municipalityId/:id/cancel'
export const validation = {
  patch: {
    tags: tagsPatchComgate_municipalityId_idCancel,
    params: paramsPatchComgate_municipalityId_idCancel,
    response: responsePatchComgate_municipalityId_idCancel
  }
}
export interface Comgate_municipalityId_idCancel extends BaseRouteType {
  patch: IPatchComgate_municipalityId_idCancel
}